import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loading } from "@/components/site/ui";
import { Stat, AdminHeading, Panel } from "@/components/admin/ui";
import AdminDashboard from "@/pages/admin/AdminDashboard";

const CFG = {
  front_desk: {
    title: "Front Desk", subtitle: "Today's arrivals, departures & readiness",
    cards: [
      ["Arrivals", "arrivals", "pool", "/admin/reservations?filter=arrivals-today"],
      ["Departures", "departures", "pool", "/admin/reservations?filter=departures-today"],
      ["In House", "in_house", "gold", "/admin/in-house"],
      ["Incomplete Check-Ins", "incomplete_checkins", "gold", "/admin/reservations?filter=incomplete-checkin"],
      ["Rooms Not Ready", "rooms_not_ready", "red", "/admin/rooms?filter=not-ready"],
      ["Rooms Ready", "rooms_ready", "gold", "/admin/rooms?filter=Ready"],
      ["Rooms Unassigned", "rooms_unassigned", "red", "/admin/rooms"],
      ["Open Maintenance", "open_maintenance", "gold", "/admin/maintenance"],
    ],
    actions: [["Front Desk", "/admin/frontdesk"], ["Reservations", "/admin/reservations"], ["Rooms & Readiness", "/admin/rooms"],
      ["Request Housekeeping", "/admin/housekeeping"], ["Report Maintenance", "/admin/maintenance"]],
  },
  housekeeping: {
    title: "Housekeeping", subtitle: "Your cleaning assignments",
    cards: [
      ["My Assignments", "hk_mine", "gold", "/admin/housekeeping"],
      ["Due Today", "hk_due_today", "pool", "/admin/housekeeping"],
      ["Overdue", "hk_overdue", "red", "/admin/housekeeping"],
      ["In Progress", "hk_in_progress", "gold", "/admin/housekeeping?status=In Progress"],
      ["Awaiting Inspection", "hk_awaiting_inspection", "pool", "/admin/housekeeping?status=Inspection Required"],
      ["Reclean Required", "hk_reclean", "red", "/admin/housekeeping?status=Reclean Required"],
      ["Rooms Ready", "rooms_ready", "gold", "/admin/rooms?filter=Ready"],
    ],
    actions: [["My Assignments", "/admin/housekeeping"], ["Rooms & Readiness", "/admin/rooms"]],
  },
  maintenance: {
    title: "Maintenance", subtitle: "Your assigned issues",
    cards: [
      ["My Issues", "maint_mine", "gold", "/admin/maintenance"],
      ["Urgent", "maint_urgent", "red", "/admin/maintenance"],
      ["Waiting for Parts", "maint_waiting_parts", "pool", "/admin/maintenance"],
      ["Waiting for Vendor", "maint_waiting_vendor", "pool", "/admin/maintenance"],
      ["Out-of-Service Units", "out_of_service", "red", "/admin/rooms?filter=Out of Service"],
      ["Open Maintenance", "open_maintenance", "gold", "/admin/maintenance"],
    ],
    actions: [["Maintenance", "/admin/maintenance"], ["Rooms & Readiness", "/admin/rooms"]],
  },
  resort_manager: {
    title: "Manager Command", subtitle: "Operational coverage & escalations",
    cards: [
      ["Arrivals", "arrivals", "pool", "/admin/reservations?filter=arrivals-today"],
      ["Departures", "departures", "pool", "/admin/reservations?filter=departures-today"],
      ["In House", "in_house", "gold", "/admin/in-house"],
      ["Rooms Not Ready", "rooms_not_ready", "red", "/admin/rooms?filter=not-ready"],
      ["Rooms Ready", "rooms_ready", "gold", "/admin/rooms?filter=Ready"],
      ["HK Overdue", "hk_overdue", "red", "/admin/housekeeping"],
      ["Awaiting Inspection", "hk_awaiting_inspection", "pool", "/admin/housekeeping?status=Inspection Required"],
      ["Open Maintenance", "open_maintenance", "gold", "/admin/maintenance"],
    ],
    actions: [["Reservations", "/admin/reservations"], ["Rooms & Readiness", "/admin/rooms"],
      ["Housekeeping", "/admin/housekeeping"], ["Maintenance", "/admin/maintenance"], ["Staff & Teams", "/admin/staff"]],
  },
};
const ROLE_MAP = { housekeeping_manager: "housekeeping", housekeeping_staff: "housekeeping",
  maintenance: "maintenance", maintenance_manager: "maintenance", front_desk: "front_desk",
  resort_manager: "resort_manager" };

function RoleDash({ cfg }) {
  const nav = useNavigate();
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/ops/summary").then((r) => setD(r.data.cards)).catch(() => setD({})); }, []);
  if (!d) return <Loading />;
  return (
    <div data-testid="role-dashboard">
      <AdminHeading title={cfg.title} subtitle={cfg.subtitle} />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        {cfg.cards.map(([label, key, accent, to]) => (
          <Stat key={key} label={label} value={d[key] ?? 0} accent={accent} testid={`rd-${key}`} onClick={() => nav(to)} />
        ))}
      </div>
      <Panel title="Quick Actions">
        <div className="flex flex-wrap gap-2">
          {cfg.actions.map(([label, to]) => (
            <button key={to} onClick={() => nav(to)} className="btn-ghost-gold px-4 py-2 text-xs" data-testid={`rd-action-${label.toLowerCase().replace(/\s/g, "-")}`}>{label}</button>
          ))}
        </div>
      </Panel>
    </div>
  );
}

export default function RoleDashboard() {
  const { user } = useAuth();
  const key = ROLE_MAP[user?.role];
  if (!key) return <AdminDashboard />;  // owner/host → full Command Center
  return <RoleDash cfg={CFG[key]} />;
}
